export default __webpack_public_path__ + "static/media/n2.2.ecc2d28e.jpeg";